import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpService } from 'src/app/services/http.service';
import { ModalService } from 'src/app/model/model.service';
import { ToastrService } from 'ngx-toastr';
import { URLUtils } from 'src/app/urlUtils';

@Component({
    selector: 'app-preview',
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.scss'],
    standalone: false
})

export class PreviewComponent implements OnInit {

  @Input() invid: any;
  @Input() id: any;

  selectedValue: string = "view";
  isDisplay: boolean = true;
  isCreate: boolean = true;
  bsValue = new Date();
  showTime = true;
  uploadDocs: any = [];
  files: File[] = [];
  fileName: File[] = [];
  descriptionForm: any;
  createinvoiceForm: any;
  invoiceForm: any;
  submitted = false;
  myForm: any;
  data: any;
  keyword = 'name';
  filter: any = "client";

  invoiceItems: any[] = [
    { description: '', no_of_units: '1', unit_price: '0', amount: '0' }
  ];

  invoice_items: any;
  calculationForm: any;
  items: any;
  matterList: any;
  groupId: any = [];
  clientId: any = [];
  relationshipSubscribe: any;

  namePattern = /^[a-zA-Z\s]*$/;
  invoice: any;
  inTax: any;
  inItems: any = [];
  successModel: boolean = false;

  @ViewChild('fileInput')
  imageUrl: any = "assets/img/logo.png";
  inDis: any;
  logo: any;
  imageToShow: any;
  isShowImage: Boolean = true;
  invoice_id: any;
  profile: any;
  dialogClosed: any;
  invoicelist: any;
  defaultDis = 'DISCOUNT';
  defaultTax = 'TAX';

  currencyList = [
    { label: "AustralianDollar (AUD)", code: "AUD", symbol: "A$" },
    { label: "Bahraini Dinar (BHD)", code: "BHD", symbol: ".د.ب" },
    { label: "CanadianDollar(CAD)", code: "CAD", symbol: "C$" },
    { label: "Euro (EUR)", code: "EUR", symbol: "€" },
    { label: "IndianRupee (INR)", code: "INR", symbol: "₹" },
    { label: "JapaneseYen (JPY)", code: "JPY", symbol: "¥" },
    { label: "Kuwaiti Dinar (KWD)", code: "KWD", symbol: "د.ك" },
    { label: "Pound (GBP)", code: "GBP", symbol: "£" },
    { label: "SwissFranc (CHF)", code: "CHF", symbol: "₣" },
    { label: "USDollar (USD)", code: "USD", symbol: "$" }
  ];
  selectedCurrency: any;

  constructor(
    private router: Router,
    private modalService: ModalService,
    private fb: FormBuilder,
    private httpservice: HttpService,
    private toast: ToastrService,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => this.invoice_id = params['id']);
    this.createinvoiceForm = this.fb.group({
      invoiceNo: [''],
      name: [''],
      billto: [''],
      date: [''],
      duedate: [''],
      invoice_items: this.fb.array([
        this.createInvoiceItem()
      ]),
      notes: [''],
      tax: [''],
      tax_type: [''],
      discount: [''],
      discount_type: [''],
      firm_gst_no: [''],
      firm_pan_no: [''],
      client_gst_no: [''],
      client_pan_no: ['']
    });

    this.getLogo();
    this.getPreview();
    this.getProfile();
  }

  selectCurrency(currency: any) {
    this.selectedCurrency = currency;
  }

  getProfile() {
    this.httpservice.sendGetRequest(URLUtils.profile).subscribe(
      (res: any) => {
        if (res.error == false) {
          this.profile = res.data?.details;
        }
      }
    );
  }

  onImageError() {
  this.imageToShow = null;
}


  getPreview() {
    this.httpservice.sendGetRequest(URLUtils.InvoiceWithId(this.invoice_id)).subscribe(
      (res: any) => {
        //console.log('preview invoice:',res)
        //console.log('show invoice:',this.invoice)

        if (res.error == false) {
          this.invoice = res?.invoice;
          this.inItems = res?.invoice?.items || [];
          this.inTax = res?.invoice?.tax_items?.[0];
          this.inDis = res?.invoice?.discounts?.[0];
          this.isShowImage = this.invoice.include_logo;

          // Handle currency code
          const code = this.invoice?.currency_code;
          const foundCurrency = this.currencyList.find(c => c.code === code);
          if (foundCurrency) {
            this.selectedCurrency = foundCurrency;
          } else {
            this.selectedCurrency = { symbol: '', label: code };
          }

          // Populate form with new fields
          this.createinvoiceForm.patchValue({
            invoiceNo: this.invoice.invoice_no,
            name: this.invoice.name,
            billto: this.invoice.billto,
            date: this.invoice.date,
            duedate: this.invoice.duedate,
            notes: this.invoice.notes,
            firm_gst_no: this.invoice.firm_gst_no,
            firm_pan_no: this.invoice.firm_pan_no,
            client_gst_no: this.invoice.client_gst_no,
            client_pan_no: this.invoice.client_pan_no
          });
        }
      }
    );
  }

  getLogo() {
    this.httpservice.sendGetRequest(URLUtils.GetLogo).subscribe(
      (res: any) => {
        if (res.error == false) {
          this.imageToShow = res?.data?.url;
        }
      }
    );
  }

  createInvoiceItem(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      no_of_units: ['', Validators.required],
      unit_price: ['', Validators.required]
    });
  }

  uploadFile(event: any) {
    let reader = new FileReader();
    let file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imageUrl = reader.result;
        this.descriptionForm.patchValue({
          file: reader.result
        });
      };
      this.cd.markForCheck();
    }
  }

  selectDuration(date: any) {
    this.bsValue = date;
  }

  isActive(value: string) {
    this.selectedValue = value;
    this.selectedValue == 'create' ? this.router.navigate(['/createinvoice']) : this.router.navigate(['/invoice']);
  }

  hideAndShow() {
    this.isDisplay = !this.isDisplay;
  }

  calculateAmount(item: any): number {
    const no_of_units = item.no_of_units || 0;
    const unit_price = item.unit_price || 0;
    return no_of_units * unit_price;
  }

  calculateTotalAmount(): number {
    let totalAmount = 0;
    for (let i = 0; i < this.inItems.length; i++) {
      totalAmount += this.calculateAmount(this.inItems[i]);
    }
    return totalAmount;
  }

  calculateTotalAmountWithOthers(): number {
    let totalAmount = 0;
    const taxPercentage = this.inTax?.tax || 0;
    const discountPercentage = this.inDis?.discount || 0;

    for (let i = 0; i < this.inItems.length; i++) {
      totalAmount += this.calculateAmount(this.inItems[i]);
    }

    let amountAfterDiscount = totalAmount;
    if (discountPercentage > 0) {
      const discountAmount = (totalAmount * discountPercentage) / 100;
      amountAfterDiscount -= discountAmount;
    }

    const taxAmount = (amountAfterDiscount * taxPercentage) / 100;
    const amountAfterTax = amountAfterDiscount + taxAmount;

    return amountAfterTax;
  }

  onSub() {
    this.successModel = true;
  }

  btnclose() {
    this.successModel = false;
  }

  downloadDoc(doc: any) {
    const params = { module: 'invoice' };
    this.httpservice.sendGetRequest(URLUtils.downloadInvoiceDocument(doc), params).subscribe((res: any) => {
      if (res.error == false) {
        // this.modalService.open('doc-download-success');
        window.open(res?.data?.url, "_blank");
        this.toast.success('You have successfully downloaded the Invoice');
      } else if (res.error == true) {
        this.toast.error(res.msg);
      }
    });
  }

  closeModal(id: string) {
    this.modalService.close(id);
    this.router.navigate(['/invoice']);
  }
}